import React, { useState, useEffect } from 'react';
import { getProductByHandle } from '../../../../../components/shared/query/query';
import { primeColorOrder, processSpecialColorName } from '../../../../ProductPage/ProductHelpers';
import { useLazyQuery } from '@apollo/client';
import { productDetailViewEvent } from '../../../../../components/shared/dataLayer/index';
import SizeChart from '../../../../ProductPage/ProductForm/SizeChartModal/SizeChart';
import Carousel from '@brainhubeu/react-carousel';
import '@brainhubeu/react-carousel/lib/style.css';
import './ProductStyle.scss';
import { addToCart, giftsDefault } from '../../../../../components/shared/cart/CartHelpers';
import { productDataParser, productSizeParser } from '../../../../ProductPage/ProductHelpers';
export default function ProductData(props) {
  const [getProductByHandleQuery, { data: getProductByHandleData, error: getProductByHandleError }] = useLazyQuery(
    getProductByHandle,
  );
  const [baseProductData, setBaseProductData] = useState({
    images: {
      edges: [],
    },
  });
  const [data, setData] = useState({});
  const [first, setFirst] = useState(false);
  const [colorHandle, setColor] = useState('');
  const [price, setPrice] = useState('5.00');
  const [vatTextState, setVatTextState] = useState(false);
  const [manOrWoman, setManOrWoman] = useState();
  const [productCode, setProductCode] = useState('');
  const [hasExceededQuantity, setHasExceededQuantity] = useState(false);
  const [errorState, setErrorState] = useState({
    message: '',
    show: false,
  });
  const [variant, setVariant] = useState();

  useEffect(() => {
    if (props.handle) {
      getProductByHandleQuery({
        variables: {
          handle: props.handle,
          currencyCode: 'EUR',
        },
      });
    }
  }, []);

  useEffect(() => {
    if (baseProductData) {
      const result = productDataParser(baseProductData, giftsDefault);
      if (result) {
        setData(result);
      }
    }
  }, [baseProductData]);

  useEffect(() => {
    if (getProductByHandleError) {
    }
    if (getProductByHandleData) {
      if (!getProductByHandleData.productByHandle) {
        window.location.replace(`${window.location.origin}/404`);
        return null;
      }

      let product = JSON.parse(JSON.stringify(getProductByHandleData.productByHandle));
      product = handleProductData(product);
      setBaseProductData(product);
    }
  }, [getProductByHandleData, getProductByHandleError]);

  function handleProductData(product) {
    let firstAvailableSizeFound = false;
    product.sizeValues = [];
    product.variants.edges.map((variant, index) => {
      if (!firstAvailableSizeFound && variant && variant.node && variant.node.availableForSale) {
        setVariant(variant.node);
      }
      variant.node.selectedOptions.map((selectedOption) => {
        if (selectedOption.name === 'Size') {
          let chosen = false;
          if (!firstAvailableSizeFound && variant.node.availableForSale) {
            firstAvailableSizeFound = true;
            chosen = true;
            product.chosenSizeAvailability = variant.node.availableForSale;
          }
          product.sizeValues.push({
            chosen,
            value: selectedOption.value,
            availableForSale: variant.node.availableForSale,
            quantityAvailable: variant.node.quantityAvailable,
          });
        } else if (index === 0 && selectedOption.name === 'Color') {
          product.chosenColorValue = selectedOption.value;
        }
        return null;
      });
      return null;
    });

    let chosenColorValueProcessed;

    if (product.chosenColorValue) {
      chosenColorValueProcessed = processSpecialColorName(product.chosenColorValue);
    } else {
      chosenColorValueProcessed = '';
    }
    product.colorValues = [];
    let selfPicked = false;
    for (const singleColorOrder of primeColorOrder) {
      if (chosenColorValueProcessed === singleColorOrder) {
        selfPicked = true;
        product.colorValues.push({
          name: chosenColorValueProcessed,
          handle: `${product.handle}`,
          chosen: true,
        });
      }

      for (const singleTag of product.tags) {
        if (singleTag.includes('handle_')) {
          let colorName = singleTag.replace('handle_', '');
          colorName = colorName.slice(0, colorName.indexOf('+'));
          const handleValue = singleTag.replace(`handle_${colorName}+`, '');

          if (singleColorOrder === colorName) {
            product.colorValues.push({
              name: colorName,
              handle: `${handleValue}`,
              chosen: false,
            });
          }
        }
      }
    }

    for (const singleTag of product.tags) {
      let mark = true;
      if (singleTag.includes('handle_')) {
        let colorName = singleTag.replace('handle_', '');
        colorName = colorName.slice(0, colorName.indexOf('+'));
        const handleValue = singleTag.replace(`handle_${colorName}+`, '');
        for (const singleColorOrder of primeColorOrder) {
          if (singleColorOrder === colorName) {
            mark = false;
            break;
          }
        }
        if (mark) {
          product.colorValues.push({
            name: colorName,
            handle: `${handleValue}`,
            chosen: false,
          });
        }
      }
    }

    if (!selfPicked) {
      product.colorValues.push({
        name: chosenColorValueProcessed,
        handle: `${product.handle}`,
        chosen: true,
      });
    }

    return product;
  }

  let ProductPriceHelper = null;
  if (baseProductData.id) {
    ProductPriceHelper = (
      <div className="tc_product_price">
        {baseProductData.variants.edges[0].node.presentmentPrices &&
          baseProductData.variants.edges[0].node.presentmentPrices.edges[0].node.compareAtPrice && (
            <div className="gr_left">
              {baseProductData.variants.edges[0].node.presentmentPrices.edges[0].node.compareAtPrice.amount &&
              baseProductData.variants.edges[0].node.presentmentPrices.edges[0].node.compareAtPrice.amount &&
              parseInt(baseProductData.variants.edges[0].node.presentmentPrices.edges[0].node.compareAtPrice.amount) >
                parseInt(baseProductData.variants.edges[0].node.presentmentPrices.edges[0].node.price.amount) ? (
                <div className="productPrice">
                  <div className="pr_price">
                    <p className="current_price">
                      {'€'}
                      {parseInt(
                        baseProductData.variants.edges[0].node.presentmentPrices.edges[0].node.compareAtPrice.amount,
                        10,
                      )}
                    </p>
                    {vatTextState === true && <span> inkl. MwSt. exkl. Versand </span>}
                  </div>
                </div>
              ) : (
                <div className="productPrice current">
                  <p>
                    {'€'}
                    {parseInt(baseProductData.variants.edges[0].node.presentmentPrices.edges[0].node.price.amount, 10)}
                  </p>
                  {vatTextState === true && <span> inkl. MwSt. exkl. Versand</span>}
                </div>
              )}
            </div>
          )}
      </div>
    );
  }

  function changeColor(handle) {
    if (handle) {
      setColor(handle);
      getProductByHandleQuery({
        variables: {
          handle: handle,
          currencyCode: 'EUR',
        },
      });
      if (getProductByHandleData) {
        if (!getProductByHandleData.productByHandle) {
          window.location.replace(`${window.location.origin}/404`);
          return null;
        }

        let product = JSON.parse(JSON.stringify(getProductByHandleData.productByHandle));
        if (product) {
          let firstAvailableSizeFound = false;
          product.sizeValues = [];
          product.variants.edges.map((variant, index) => {
            variant.node.selectedOptions.map((selectedOption) => {
              if (selectedOption.name === 'Size') {
                let chosen = false;
                if (!firstAvailableSizeFound && variant.node.availableForSale) {
                  firstAvailableSizeFound = true;
                  chosen = true;
                  product.chosenSizeAvailability = variant.node.availableForSale;
                }
                product.sizeValues.push({
                  chosen,
                  value: selectedOption.value,
                  availableForSale: variant.node.availableForSale,
                  quantityAvailable: variant.node.quantityAvailable,
                });
              } else if (index === 0 && selectedOption.name === 'Color') {
                product.chosenColorValue = selectedOption.value;
              }
              return null;
            });
            return null;
          });

          let chosenColorValueProcessed;

          if (product.chosenColorValue) {
            chosenColorValueProcessed = processSpecialColorName(product.chosenColorValue);
          } else {
            chosenColorValueProcessed = '';
          }
          product.colorValues = [];
          let selfPicked = false;
          for (const singleColorOrder of primeColorOrder) {
            if (chosenColorValueProcessed === singleColorOrder) {
              selfPicked = true;
              product.colorValues.push({
                name: chosenColorValueProcessed,
                handle: `${product.handle}`,
                chosen: true,
              });
            }

            for (const singleTag of product.tags) {
              if (singleTag.includes('handle_')) {
                let colorName = singleTag.replace('handle_', '');
                colorName = colorName.slice(0, colorName.indexOf('+'));
                const handleValue = singleTag.replace(`handle_${colorName}+`, '');

                if (singleColorOrder === colorName) {
                  product.colorValues.push({
                    name: colorName,
                    handle: `${handleValue}`,
                    chosen: false,
                  });
                }
              }
            }
          }

          for (const singleTag of product.tags) {
            let mark = true;
            if (singleTag.includes('handle_')) {
              let colorName = singleTag.replace('handle_', '');
              colorName = colorName.slice(0, colorName.indexOf('+'));
              const handleValue = singleTag.replace(`handle_${colorName}+`, '');
              for (const singleColorOrder of primeColorOrder) {
                if (singleColorOrder === colorName) {
                  mark = false;
                  break;
                }
              }
              if (mark) {
                product.colorValues.push({
                  name: colorName,
                  handle: `${handleValue}`,
                  chosen: false,
                });
              }
            }
          }

          if (!selfPicked) {
            product.colorValues.push({
              name: chosenColorValueProcessed,
              handle: `${product.handle}`,
              chosen: true,
            });
          }

          return setBaseProductData(product);
        }
      }
    }
  }

  function changeSize(sizeName) {
    let priceList =
      sizeName === 'S-60x25x30cm'
        ? '5.00'
        : sizeName === 'M-75x35x25cm'
        ? '6.00'
        : sizeName === 'L-90x40x20cm'
        ? '8.00'
        : '';
    setPrice(priceList);
    setErrorState({
      message: '',
      show: false,
    });
    setFirst(true);
    setHasExceededQuantity(false);
    const clonedProductData = JSON.parse(JSON.stringify(baseProductData));
    let chosenSize = '';
    for (const singleSize of clonedProductData.sizeValues) {
      singleSize.chosen = false;
      if (singleSize.value === sizeName) {
        singleSize.chosen = true;
        chosenSize = singleSize;
        clonedProductData.chosenSizeAvailability = singleSize.availableForSale;
      }
    }

    setBaseProductData(clonedProductData);

    if (window.dataLayer) {
      let chosenVariant;
      for (let singleVairantEdge of clonedProductData.variants.edges) {
        if (singleVairantEdge.node.selectedOptions[0].value === chosenSize.value) {
          chosenVariant = singleVairantEdge.node;
          setVariant(chosenVariant);
          break;
        }
      }
      if (chosenVariant) {
        let sendingProduct = {
          name: clonedProductData.title && clonedProductData.title.replace("'", ''),
          id: (chosenVariant && chosenVariant.sku) || '',
          productId: clonedProductData.id && atob(clonedProductData.id).replace('gid://shopify/Product/', ''),
          variantId: (chosenVariant.id && atob(chosenVariant.id).replace('gid://shopify/ProductVariant/', '')) || '',
          price: chosenVariant.priceV2 && parseInt(chosenVariant.priceV2.amount),
          compareAtPrice: chosenVariant.compareAtPriceV2 && parseInt(chosenVariant.compareAtPriceV2.amount),
          variant: (chosenVariant && chosenVariant.title && chosenVariant.title.replace("'", '')) || '',
          category: clonedProductData.productType.replace("'", '') || '',
          inventoryCount: chosenVariant.quantityAvailable,
        };
        productDetailViewEvent(sendingProduct);
      }
    }
  }

  return (
    <div className="production-slider">
      <Carousel
        slidesPerPage={2}
        slidesPerScroll={1}
        animationSpeed={300}
        centered
        clickToChange
        infinite
        addArrowClickHandler
        arrows
        breakpoints={{
          1000: {
            // these props will be applied when screen width is less than 1000px
            slidesPerPage: 2,
            clickToChange: false,
            centered: true,
            arrows: true,
            infinite: true,
          },
          850: {
            // these props will be applied when screen width is less than 850px
            slidesPerPage: 3,
            clickToChange: false,
            centered: true,
            arrows: true,
            infinite: true,
          },
          650: {
            // these props will be applied when screen width is less than 650px
            slidesPerPage: 3,
            clickToChange: false,
            centered: true,
            arrows: true,
            infinite: true,
          },
          500: {
            slidesPerPage: 1,
            slidesPerScroll: 1,
            clickToChange: false,
            centered: true,
            animationSpeed: 2000,
            infinite: true,
          },
        }}
      >
        {baseProductData &&
          baseProductData.images.edges.map((item, i) => (
            <span key={i}>
              <img
                alt={item.altText}
                style={{ objectFit: 'fill' }}
                srcSet={
                  `${item.node.originalSrc.replace('.jpg', '_260x.jpg')} 260w,` +
                  `${item.node.originalSrc.replace('.jpg', '_390x.jpg')} 390w,` +
                  `${item.node.originalSrc.replace('.jpg', '_468x.jpg')} 468w,` +
                  `${item.node.originalSrc.replace('.jpg', '_560x.jpg')} 560w,` +
                  `${item.node.originalSrc.replace('.jpg', '_640x.jpg')} 640w,` +
                  `${item.node.originalSrc.replace('.jpg', '_750x.jpg')} 750w,` +
                  `${item.node.originalSrc.replace('.jpg', '_828x.jpg')} 828w,` +
                  `${item.node.originalSrc.replace('.jpg', '_1080x.jpg')} 1080w,` +
                  `${item.node.originalSrc.replace('.jpg', '_1280x.jpg')} 1280w,`
                }
                width="288"
                height="432"
              />
            </span>
          ))}
      </Carousel>

      <div className="production-detail-style">
        {baseProductData && (
          <>
            <p>
              {props.handle === 'luxuriose-geschenkbox' ? (
                <span style={{ textTransform: 'none' }}>Luxuriöse Geschenkbox</span>
              ) : (
                baseProductData.title
              )}
            </p>
            <div className="production-shipp-price">
              {props.handle === 'luxuriose-geschenkbox' ? (
                <div className="tc_product_price">
                  <div className="gr_left">
                    <div className="productPrice">
                      <div className="pr_price">
                        <p className="current_price">
                          {' '}
                          {'€'} {price}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              ) : ProductPriceHelper ? (
                ProductPriceHelper
              ) : (
                ''
              )}
            </div>

            <div className="clothe-heading">
              <div className="coup-clothe-product">
                {baseProductData && baseProductData.id && baseProductData.variants && (
                  <>
                    {props.handle === 'luxuriose-geschenkbox' ? (
                      ''
                    ) : (
                      <div className="clothe_color">
                        <div className="colorTitle">
                          <p>
                            Farbe
                            <span>
                              - {baseProductData.id && baseProductData.variants && baseProductData.chosenColorValue}
                            </span>
                          </p>
                        </div>
                        <div className="colorVarientForm">
                          {baseProductData &&
                            baseProductData.colorValues.map((item, i) => (
                              <span key={i}>
                                {item.chosen ? (
                                  <div
                                    key={i}
                                    className="singleColorVariantBox"
                                    style={{ border: '1px solid #18a0fb' }}
                                  >
                                    <div
                                      className="innerSingleColorBox"
                                      style={{
                                        backgroundImage: `url(https://cdn.shopify.com/s/files/1/0249/6551/3262/t/44/assets/${item.name}_50x.png?v=)`,
                                      }}
                                    ></div>
                                  </div>
                                ) : (
                                  <div key={i} className="singleColorVariantBox">
                                    <div
                                      className="innerSingleColorBox"
                                      style={{
                                        backgroundImage: `url(https://cdn.shopify.com/s/files/1/0249/6551/3262/t/44/assets/${item.name}_50x.png?v=)`,
                                      }}
                                      onClick={() => changeColor(item.handle)}
                                    />
                                  </div>
                                )}
                              </span>
                            ))}
                        </div>
                      </div>
                    )}

                    <div className="tc_product_size">
                      <div className="sizeTitle">
                        <span className="s_tt">
                          {'Größe'}
                          {baseProductData.sizeValues.map((item, index) =>
                            item.chosen ? (
                              <div key={index} className={`left_size ${item.availableForSale ? '' : 'notAvailable'}`}>
                                <span>- {item.value}</span>
                              </div>
                            ) : null,
                          )}
                        </span>

                        <div className="size_chart">
                          <SizeChart productCode={data.productCode} manOrWoman={data.gender} />

                          {/* <ShippSize productCode={productCode} manOrWoman={manOrWoman} /> */}
                        </div>
                      </div>
                      <div className={!errorState.show ? 'size-section' : 'size-section errorSize'}>
                        <ul className="sizeLists">
                          {baseProductData.sizeValues // @ts-ignore
                            .map((item, index) => (
                              <li key={index} className={`${item.value.length > 4 ? 'lengthHigh' : ''}`}>
                                {item.chosen && first === true ? (
                                  <div className={`sizeBox ${item.availableForSale ? '' : 'notAvailable'}`}>
                                    <span data-size={item.value}>{productSizeParser(item.value, data.gender)}</span>
                                  </div>
                                ) : (
                                  <div
                                    onClick={() => changeSize(item.value)}
                                    className={item.availableForSale ? '' : 'notAvailable'}
                                  >
                                    <span data-size={item.value}>{productSizeParser(item.value, data.gender)}</span>
                                  </div>
                                )}
                              </li>
                            ))}
                        </ul>
                      </div>
                      <div style={{ display: errorState.show ? 'block' : 'none' }} className="sizeErrorMessage">
                        {errorState.message}
                      </div>
                    </div>
                  </>
                )}
              </div>

              <div className="modal-price-total">
                <div className="btn">
                  <button
                    aria-label={'In den Warenkorb'}
                    className="addToCartBtn"
                    disabled={props.hasExceededQuantity}
                    onClick={() => {
                      if (first === false) {
                        setErrorState({
                          message: 'Bitte Größe wählen.',
                          show: true,
                        });
                      } else {
                        setErrorState({
                          message: '',
                          show: false,
                        });
                        props.AddToCard(true);
                        addToCart(variant, giftsDefault, baseProductData);
                      }
                    }}
                  >
                    {'In den Warenkorb'}
                  </button>
                  {props.handle === 'luxuriose-geschenkbox' ? (
                    ''
                  ) : (
                    <div className="back-btn-product" onClick={() => props.backHandle(props.handle)}>
                      Zurück zur Sammlung
                    </div>
                  )}
                </div>
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
